import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { RootState } from 'store';

import { searchAirport } from 'actions/airports';
import GooglePlacesSearch from 'components/GooglePlacesSearch';
import PlacesSearch from 'components/PlacesSearch';
import { Airport } from 'models/airport';
import { VehiclePlace } from 'models/auto/vehicleSearch';
import { City } from 'models/city';
import { BySearchType } from 'reducers/airports';

interface Props {
  show: boolean;
  placeHolder: string;
  onClose: () => void;
  onChange: (place?: Airport | City | VehiclePlace, isCity?: boolean) => void;
  isPickUp: boolean;
}

const mapPlacesToVehiclePlace = (places: google.maps.places.AutocompletePrediction[], query?: string): VehiclePlace[] =>
  places.map((place) => ({
    description: place.description,
    code: '',
    related_city: '',
    state: '',
    country: place.description.substring(place.description.lastIndexOf(',') + 2),
    highlight_description: query ? query : '',
    isAirport: false,
    latitude: 0,
    longitude: 0,
    placeId: place.place_id,
    airport_code: ''
  }));

const PlacesSearchContainer = ({ onChange, isPickUp, ...props }: Props) => {
  const dispatch = useDispatch();
  const airportsState = useSelector((state: RootState) => state.airports);
  const [query, setQuery] = useState('');
  const [isGoogleSearching, setGoogleSearching] = useState(false);
  const [places, setPlaces] = useState<VehiclePlace[]>([]);
  const [selected, setSelected] = useState<Airport | City | VehiclePlace | undefined>();
  const [selectedIsCity, setSelectedIsCity] = useState(false);

  const handleSearchChange = _.debounce((value: string) => {
    if (value && value.length > 2) {
      const type = isPickUp ? BySearchType.PICKUP : BySearchType.DROPOFF;

      dispatch(searchAirport(value, type));
      setQuery(value);
    }
  }, 250);

  const handleClick = (place?: Airport | City | VehiclePlace, isCity?: boolean) => {
    if (place) setSelected(place);
    setSelectedIsCity(isCity ? true : false);
  };

  const onSelected = (place?: Airport | City | VehiclePlace) => {
    onChange(place, selectedIsCity);
    setSelected(undefined);
    setSelectedIsCity(false);
  };

  const onSearchStart = () => {
    setPlaces([]);
    setGoogleSearching(true);
  };

  const onSearchEnd = (results: google.maps.places.AutocompletePrediction[]) => {
    setGoogleSearching(false);
    const result = mapPlacesToVehiclePlace(results, query);
    setPlaces([...result]);
  };

  return (
    <GooglePlacesSearch
      query={query}
      onStart={onSearchStart}
      onEnd={onSearchEnd}
      onSelected={onSelected}
      selected={selected}
    >
      <PlacesSearch
        {...props}
        {...airportsState}
        isSearching={isGoogleSearching}
        places={places}
        minLengthForSearch={2}
        onChange={handleClick}
        onSearchChange={handleSearchChange}
        isPickUp={isPickUp}
      />
    </GooglePlacesSearch>
  );
};

export default PlacesSearchContainer;
